import { h } from 'preact';
export const Package = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("line", { x1: "16.5", y1: "9.4", x2: "7.5", y2: "4.21" }),
        h("path", { d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" }),
        h("polyline", { points: "3.27 6.96 12 12.01 20.73 6.96" }),
        h("line", { x1: "12", y1: "22.08", x2: "12", y2: "12" })));
};
//# sourceMappingURL=package.js.map